import React from 'react'
import './Button.css'

function index({title}) {
    return (
        <div className="button">
            <button>
            
            <span>{title}</span>
          </button>
        </div>
    )
}

export default index
